import { render, staticRenderFns } from "./Protocols.vue?vue&type=template&id=031a2a92&scoped=true&"
import script from "./Protocols.vue?vue&type=script&lang=js&"
export * from "./Protocols.vue?vue&type=script&lang=js&"
import style0 from "./Protocols.vue?vue&type=style&index=0&id=031a2a92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a2a92",
  null
  
)

export default component.exports